import { ISerpPlugin } from '~/plugins/SerpPlugin';

/**
 * Imports index.ts of a given plugin if found in plugins/packages directory
 * Does not throw any errors, only logs to console in debug mode
 *
 * @returns plugin instance if found, otherwise returns null
 */
const loadPlugin = (pluginName: string, debug: boolean): Promise<ISerpPlugin | null> => {
    return import(
        /* webpackChunkName: "plugins/[request]" */
        /* webpackPreload: true */
        `../plugins/packages/${pluginName}/index`
    )
        .then(({ default: SerpPlugin }) => {
            return new SerpPlugin();
        })
        .catch((error) => {
            if (debug) {
                console.error('SEARCH READY ERROR: plugin loading failed');
                console.error(error);
            }

            return null;
        });
};

export default loadPlugin;
